// ResetPassword.jsx
import React, { useState } from 'react';
import { Input, Button, Form } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from '../components/Axios';
import './Login.css';

function ResetPassword() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post('/auth/reset-password', values);

      if (response.data) {
        toast.success('🎉 Password updated successfully! Redirecting to login...', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
        });

        setTimeout(() => navigate('/login'), 2000);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Password reset failed. Please try again.';
      toast.error(`😕 ${errorMessage}`, {
        position: "top-right",
        autoClose: 5000
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="login-left">
          <div className="left-content">
            <h2>Reset Your Password</h2>
            <div className="features-list">
              <div className="feature-item">
                <div className="feature-icon">🔑</div>
                <div className="feature-text">
                  <h4>Quick & Simple</h4>
                  <p>Enter your email and new password to regain access to your account.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="login-right">
          <div className="login-box">
            <div className="login-header">
              <h1>Reset Password</h1>
            </div>

            <Form
              form={form}
              name="reset-password"
              onFinish={handleSubmit}
              layout="vertical"
              className="login-form"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Please enter a valid email!' }
                ]}
              >
                <Input
                  size="large"
                  prefix={<MailOutlined className="site-form-item-icon" />}
                  placeholder="Email address"
                  className="custom-input"
                />
              </Form.Item>

              <Form.Item
                name="newPassword"
                rules={[
                  { required: true, message: 'Please input your new password!' },
                  { min: 8, message: 'Password must be at least 8 characters!' }
                ]}
                extra="Must be at least 8 characters long"
              >
                <Input.Password
                  size="large"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="New password"
                  className="custom-input"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  block
                  htmlType="submit"
                  loading={loading}
                  className="submit-button"
                >
                  {loading ? 'Updating Password...' : 'Reset Password'}
                </Button>
              </Form.Item>
            </Form>

            <div className="register-link">
              Remembered your password?{' '}
              <span onClick={() => navigate('/login')}>Log in</span>
            </div>

          </div>
        </div>
      </div>
      {/* <ToastContainer /> */}
    </div>
  );
}

export default ResetPassword;